import 'intl';
import 'core-js/es6/array';
import 'core-js/es6/date';
import 'core-js/es6/function';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/object';
import 'core-js/es6/string';
import 'core-js/es6/symbol';
import 'core-js/es6/promise';

if (!Object.values) {
    Object.defineProperty(Object, 'values', {
        configurable: true,
        enumerable: false,
        value: function(object) {
            return Object.keys(object).map(function(key) {
                return object[key];
            });
        },
        writable: true
    });
}

if (!Object.entries) {
    Object.entries = function(obj) {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
        while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
    };
}



// WEBPACK FOOTER //
// ./src/polyfills.js